export enum ContractStepNames {
  SELECT_SCHOOL = 'School',
  SELECT_INSTRUMENT = 'Instrument',
  OPTIONS_ACCESSORIES = 'Options',
  PAYMENT = 'Payment',
}
